import Joi from 'joi-browser'
import { HOTEL_AND_CAR, FLIGHT_AND_CAR, HOTEL_FLIGHT_CAR } from '../../constants/Constants'

const dateSchema = Joi.date().timestamp()

const START_LOCATION_REQUIRED = 'Please select a pick-up location'
const END_LOCATION_REQUIRED = 'Please select a drop-off location'
const WHERE_FROM_LOCATION_REQUIRED = 'Please enter a city or an airport'
const WHERE_TO_LOCATION_REQUIRED = 'Please enter a city or an airport'
const INVALID_LOCATION = 'Please enter a valid location'
const START_DATE_REQUIRED = 'Please select a pick-up date'
const END_DATE_REQUIRED = 'Please select a drop-off date'
const DATE_REQUIRED_FOR_PACKAGE = 'Please select valid dates'
const START_TIME_REQUIRED = 'Please select a pick-up time'
const END_TIME_REQUIRED = 'Please select a drop-off time'
const DISALLOW_INFANT_INTL_FLIGHT = 'Priceline does not support lap infants on international flights'
const END_TIME_LATER =
  'Please make sure the drop-off date is the same or later than the pick-up date'
const CHILD_AGE_REQUIRED =
  "Please enter children's age to get the best price for your group"
const TRAVELERS_PER_ROOM = 4
const ROOM_CAPACITY_ERROR =
  'Rooms accommodate up to 4 people. You may need additional rooms for your group'

const isMultiTripType = tripType => [HOTEL_FLIGHT_CAR, HOTEL_AND_CAR, FLIGHT_AND_CAR].some(type => type === tripType)

// not sure if these will ever show in the UI
const INVALID_DATE = 'Please enter a valid date'

const validate = (
  {
    startLocation,
    endLocation,
    startLocationObject,
    endLocationObject,
    startDate,
    endDate,
    startTime,
    endTime,
    oneWay,
    tripType,
    childrenCount,
    childrenAges,
    roomCount,
    adultCount
  } = {}
) => {
  const errors = {}

  if (tripType === HOTEL_AND_CAR || tripType === FLIGHT_AND_CAR || tripType === HOTEL_FLIGHT_CAR) {
    const isChildrenAgesArray = Array.isArray(childrenAges)
    const isChildrenAgeDataValid = isChildrenAgesArray && childrenAges.length >= 0
    const numOfValidAges =
      isChildrenAgesArray && childrenAges.filter(age => age >= 0)
    const intlStartLocation = !!(
      startLocationObject &&
      typeof startLocationObject.countryCode === 'string' &&
      startLocationObject.countryCode.toUpperCase() !== 'US'
    )

    const intlEndLocation = !!(
      endLocationObject &&
      typeof endLocationObject.countryCode === 'string' &&
      endLocationObject.countryCode.toUpperCase() !== 'US'
    )

    const isInfantFound = !!(
      Array.isArray(childrenAges) && childrenAges.find(age => age === '0')
    )

    const isStartLocationWithInfant = intlStartLocation && isInfantFound
    const isEndLocationWithInfant = intlEndLocation && isInfantFound

    if (tripType === FLIGHT_AND_CAR || tripType === HOTEL_FLIGHT_CAR) {
      if (isStartLocationWithInfant || isEndLocationWithInfant) {
        errors.intlLapInfant = DISALLOW_INFANT_INTL_FLIGHT
      }
    }
    if (
      childrenCount > 0 &&
      isChildrenAgeDataValid &&
      childrenCount !== numOfValidAges.length
    ) {
      errors.childAge = CHILD_AGE_REQUIRED
    }

    const travelerCount = adultCount + childrenCount
    const allowedTravelerCount = roomCount * TRAVELERS_PER_ROOM
    if (allowedTravelerCount < travelerCount && tripType.includes('STAY')) {
      errors.roomCapacity = ROOM_CAPACITY_ERROR
    }
  }

  if (!startLocation) {
    if ([FLIGHT_AND_CAR, HOTEL_FLIGHT_CAR].includes(tripType)) {
      errors.startLocation = WHERE_FROM_LOCATION_REQUIRED
    } else if (tripType !== HOTEL_AND_CAR) {
      errors.startLocation = START_LOCATION_REQUIRED
    }
  }

  if (!endLocation) {
    if ([FLIGHT_AND_CAR, HOTEL_FLIGHT_CAR].includes(tripType)) {
      errors.endLocation = WHERE_TO_LOCATION_REQUIRED
    } else if (tripType === HOTEL_AND_CAR) {
      errors.endLocation = INVALID_LOCATION
    } else if (oneWay) {
      errors.endLocation = END_LOCATION_REQUIRED
    }
  }

  if (!startDate) {
    errors.startDate = START_DATE_REQUIRED
    if (isMultiTripType(tripType)) {
      errors.startDate = DATE_REQUIRED_FOR_PACKAGE
    }
  } else {
    // type validation
    const startDateValidation = Joi.validate(startDate, dateSchema)
    if (startDateValidation.error) {
      errors.startDate = INVALID_DATE
    }
  }

  if (!endDate) {
    errors.endDate = END_DATE_REQUIRED
    if (isMultiTripType(tripType)) {
      errors.endDate = DATE_REQUIRED_FOR_PACKAGE
    }
  } else {
    const endDateValidation = Joi.validate(endDate, dateSchema)
    if (endDateValidation.error) {
      errors.endDate = INVALID_DATE
    }
  }

  if (startDate && endDate && startDate > endDate) {
    errors.endDate = END_TIME_LATER
  }

  if (!startTime) {
    errors.startTime = START_TIME_REQUIRED
  }

  if (!endTime) {
    errors.endTime = END_TIME_REQUIRED
  }

  return errors
}

export default validate
